import { Device, ICheckParams, IDeleteDevice } from '~/utils/interface/device';
import axiosClient from './axiosClient';

const deviceApi = {
  getDevices() {
    return axiosClient.get('/api/device/getall');
  },
  checkDevice(params: ICheckParams) {
    return axiosClient.get(`/api/device/check`, { params });
  },
  updateDevice(data: Device) {
    return axiosClient.post(`/api/device/update`, data);
  },
  deleteDevice(data: IDeleteDevice) {
    return axiosClient.delete(`/api/device/delete`, { data });
  },
  getByInstallation(id: number) {
    return axiosClient.get(`/api/device/get-by-installation/${id}`);
  },
  getByUserList(username: string) {
    return axiosClient.get(`/api/device/list-by-user/${username}`);
  },
};
export default deviceApi;
